import { SubmissionInfoItem } from '../../../models/shared/submission-info-item';
import { BeneficiaryEntityTypeEnum } from '../enums/beneficiary-entity-type.enum';

export class BeneficiaryDetailsChanges {
  public fullName: string = '';
  public new: SubmissionInfoItem[] = [];
  public previous: SubmissionInfoItem[] = [];
  public entityType: BeneficiaryEntityTypeEnum = BeneficiaryEntityTypeEnum.Individual;
}
